
import i18n from '../lang/i18n'
let password = ''//密码
let newPasswordTest = ''//新密码(修改密码)

/* 验证空格 */

export function validateSpace(rule, value, callback) {
    if (value.indexOf(" ") != -1) {
        return callback(new Error(i18n.t('config.text23')))
    } else {
        callback()
    }
}

/* 验证空格中文 */

export function validateSpaceChines(rule, value, callback) {
    let t = new RegExp("[\\u4E00-\\u9FFF]+","g");
    if (value.indexOf(" ") != -1) {
        return callback(new Error(i18n.t('config.text23')))
    } else if(t.test(value)){
        return callback(new Error("链接不能含有中文"))
    }
    else {
        callback()
    }
}




/* 验证账号 */

export function validateUsername(rule, value, callback) {
    if (value === '') {
        return callback(new Error(i18n.t('config.text17')))
    } else if (value.indexOf(" ") != -1) {
        return callback(new Error(i18n.t('config.text23')))
    } else {
        callback()
    }
}

/* 验证密码 */

export function validatePassword(rule, value, callback) {
    if (value == '') {
        return callback(new Error(i18n.t('config.text18')))
    } else if (value.indexOf(" ") != -1) {
        return callback(new Error(i18n.t('config.text19')))
    } else if (value.length < 6 || value.length > 18) {
        return callback(new Error(i18n.t('config.text20')))
    } else {
        password = value
        callback()
    }
}


/* 验证6位字符串，唯一不重复，小写字母、数字、或组合 */

export function validateStr(rule, value, callback) {
    // let t = /^\w{6,18}$/;
    if (value === '') {
        return callback(new Error(i18n.t('config.text21')))
    } else if (value.length != 6) {
        return callback(new Error(i18n.t('config.text22')))
    } else if (value.indexOf(" ") != -1) {
        return callback(new Error(i18n.t('config.text23')));
    } else {
        callback()
    }
}


// 验证重复密码
export function pwdAgainCheck(rule, value, callback) {
    if (value.length < 1) {
        return callback(new Error(i18n.t('config.text24')));
    } else if (password != value) {
        return callback(new Error(i18n.t('config.text25')));
    } else {
        callback()
    }
}

//修改密码 原密码验证
export function oldPsw(rule, value, callback) {
    if (value === '') {
        return callback(new Error(i18n.t('omission.text39')))
    } else if (value.length < 6 || value.length > 18) {
        return callback(new Error(i18n.t('config.text20')))
    } else if (value.indexOf(" ") != -1) {
        return callback(new Error(i18n.t('config.text23')));
    } else {
        callback()
    }
}

//修改密码 新密码验证
export function newPsw(rule, value, callback) {
    if (value === '') {
        return callback(new Error(i18n.t('omission.text40')))
    } else if (value.length < 6 || value.length > 18) {
        return callback(new Error(i18n.t('config.text20')))
    } else if (value.indexOf(" ") != -1) {
        return callback(new Error(i18n.t('config.text23')));
    } else {
        newPasswordTest = value
        callback()
    }
}

//修改密码 确认新密码验证
export function confirmPsw(rule, value, callback) {
    if (value.length < 1) {
        return callback(new Error(i18n.t("omission.text41")));
    } else if (newPasswordTest != value) {
        return callback(new Error(i18n.t("config.text25")));
    } else {
        callback();
    }
}

/* 验证邮箱 */

export function validatEmailAddress(rule, value, callback) {
    let t = /[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/;
    if (value === '') {
        return callback(new Error(i18n.t('config.text26')))
    } else if (!t.test(value)) {
        return callback(new Error(i18n.t('config.text27')))
    } else {
        callback()
    }
}

// 验证名称15字以内，唯一不重复
export function validatName(rule, value, callback) {
    if (value.length < 1) {
        return callback(new Error(i18n.t('config.text21')));
    } else if (value.length > 15) {
        return callback(new Error(i18n.t('config.text28')));
    } else if (value.trim().length == 0) {
        return callback(new Error(i18n.t('config.text34')));
    } else {
        callback()
    }
}

// 验证描述50字以内
export function validatDescribe(rule, value, callback) {
    if (value == '') {
        return callback(new Error(i18n.t('config.text21')));
    }
    if (value && value.length > 50) {
        return callback(new Error(i18n.t('config.text28')));
    } else {
        callback()
    }
}


// 验证是否有值
export function validatArrLength(rule, value, callback) {
    if (value && value.length < 1) {
        return callback(new Error(i18n.t('config.text29')));
    } else {
        callback()
    }
}


/* 验证版本号 */
export function validatEdition(rule, value, callback) {
    let t = /^([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/;
    if (value === '') {
        return callback(new Error(i18n.t('config.text30')))
    } else if (!t.test(value)) {
        return callback(new Error(i18n.t('config.text31')))
    } else {
        callback()
    }
}

/* 大小写字母数字下划线或组合 */
export function validatFirmware(rule, value, callback) {
    let t = /^\w{1,32}$/;
    if (value === '') {
        return callback(new Error(i18n.t('config.text30')))
    } else if (!t.test(value)) {
        return callback(new Error(i18n.t('pages.equipment.text222')))
    } else {
        callback()
    }
}
